module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/swiss-e3861e7e58e8743effd2b28162ad363d.jpg";